// extracted by mini-css-extract-plugin
module.exports = {"brick":"styles_brick__38V6M styles_cementComposition__2d9kG","text":"styles_text__iYBQR typography_defaultText__3yE-Q"};